import { type FunctionComponent, type MouseEvent } from 'react';
import classnames from 'classnames';
import { getLinks } from './getLinks';
import { PageLinksItem } from './PageLinksItem';

import styles from './styles/main.scss';

type PageLinksProps = {
    numberOfPages: number;
    currentPage: number;
    onPageChange: (args: { e: MouseEvent<HTMLElement>; pageNumber: number }) => void;
    getPageLinkUrl?: (pageNumber: number) => string;
    totalPageLinks?: number;
    showNumbers?: boolean;
};

export const PageLinks: FunctionComponent<PageLinksProps> = ({
    currentPage,
    numberOfPages,
    onPageChange,
    getPageLinkUrl,
    totalPageLinks = 6,
    showNumbers = true,
}) => {
    if (numberOfPages <= 1) {
        return null;
    }

    const generatedPageLinks = getLinks({
        numberOfPages,
        currentPage,
        totalPageLinks,
        showNumbers,
    });

    return (
        <ul className={styles.pageLinkList} data-tp={numberOfPages} data-tn="pageLink-list">
            {generatedPageLinks.map(({ type, key, pageNumber, isSelected }) => (
                <li
                    key={key}
                    className={classnames(styles.pageLinkItem, {
                        [styles.arrowWrapperPrev]: type === 'BACK',
                        [styles.arrowWrapperNext]: type === 'FORWARD',
                        [styles.arrowWrapper]: ['BACK', 'FORWARD'].includes(type),
                    })}
                >
                    <PageLinksItem
                        type={type}
                        numberOfPages={numberOfPages}
                        pageNumber={pageNumber}
                        isSelected={isSelected}
                        currentPage={currentPage}
                        onLinkClick={onPageChange}
                        getPageLinkUrl={getPageLinkUrl}
                    />
                </li>
            ))}
        </ul>
    );
};
